'use client';

import { c as _c } from "react/compiler-runtime";
import { SWRConfig } from 'swr';
import fetcherLib from 'commons/fetcher';
import fetchWithTimeout from './fetchWithTimeout';
const fetcher = (url, options) => fetchWithTimeout(fetcherLib, [url, options]);

// This provider allows us to configure the SWR library with useful defaults
// such as a custom fetcher, and to preload specific responses from the server
// by using the fallback object.
const SWRClientProvider = t0 => {
  const $ = _c(5);
  const {
    children,
    fallback
  } = t0;
  let t1;
  if ($[0] !== fallback) {
    t1 = {
      fallback,
      fetcher
    };
    $[0] = fallback;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <SWRConfig value={t1}>{children}</SWRConfig>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export default SWRClientProvider;